/**
 * @generated SignedSource<<339f445a9bd403393ad20a67b6968d24>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PullRequestState = "CLOSED" | "MERGED" | "OPEN" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ConnectedEvent$data = {
  readonly actor: {
    readonly " $fragmentSpreads": FragmentRefs<"EventActor" | "EventActorAvatarItemBadge">;
  } | null;
  readonly createdAt: string;
  readonly databaseId: number | null;
  readonly subject: {
    readonly isDraft?: boolean;
    readonly isInMergeQueue?: boolean;
    readonly number?: number;
    readonly repository?: {
      readonly name: string;
      readonly owner: {
        readonly login: string;
      };
    };
    readonly state?: PullRequestState;
    readonly title?: string;
    readonly url?: string;
  };
  readonly " $fragmentType": "ConnectedEvent";
};
export type ConnectedEvent$key = {
  readonly " $data"?: ConnectedEvent$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConnectedEvent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConnectedEvent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "databaseId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "actor",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EventActor"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EventActorAvatarItemBadge"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "subject",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "number",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "state",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isDraft",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isInMergeQueue",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Repository",
              "kind": "LinkedField",
              "name": "repository",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "owner",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "login",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "PullRequest",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ConnectedEvent",
  "abstractKey": null
};

(node as any).hash = "945f3b61d38e0a700edde4100715cabb";

export default node;
